module.exports = __webpack_public_path__ + "ng.f2ea94b40cede944fc9b.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ng.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ng.svg
// module chunks = styles